import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 15 14",
  "content": "<symbol viewBox=\"0 0 15 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-right\">\n<path d=\"M12.7463 6.375H1.125C0.9425 6.375 0.792708 6.43354 0.675625 6.55062C0.558542 6.66771 0.5 6.8175 0.5 7C0.5 7.1825 0.558542 7.33229 0.675625 7.44938C0.792708 7.56646 0.9425 7.625 1.125 7.625H12.7463L8.17562 12.1756C8.05854 12.306 8 12.4558 8 12.625C8 12.7942 8.06188 12.9406 8.18563 13.0644C8.30938 13.1881 8.45583 13.25 8.625 13.25C8.79417 13.25 8.94396 13.1915 9.07438 13.0744L14.6994 7.44938C14.8165 7.31896 14.875 7.16917 14.875 7C14.875 6.83083 14.8165 6.68104 14.6994 6.55062L9.07438 0.925625C8.94396 0.808542 8.79417 0.75 8.625 0.75C8.45583 0.75 8.30938 0.811875 8.18563 0.935625C8.06188 1.05937 8 1.20583 8 1.375C8 1.54417 8.05854 1.69396 8.17562 1.82437L12.7463 6.375Z\" fill=\"#314455\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/right.svg
// module id = +iKq
// module chunks = 262